export class AjaxExceptionError extends Error {
  constructor(err,action) {
    super();
    this.stack = err.stack;
    this.action = action;
    this.response = err.response
    this.config = err.config
    this.isAxiosError = err.isAxiosError
    this.request = err.request
    this.toJSON = err.toJSON
    this.message = err.message;
  }
}
